import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs: FAQItem[] = [{
    question: 'Does It Work On Potatoes As Well As Apples?',
    answer: 'Yes! The KNOVA™ Automatic Peeler Machine works perfectly on apples, potatoes, pears, and other round fruits and vegetables. It automatically adjusts to different sizes and shapes for consistent peeling results.'
  }, {
    question: 'Is It Safe To Use?',
    answer: "Absolutely! The machine is designed with safety in mind. It's completely hands-free, so your fingers never come near the peeling blade. The automatic mechanism ensures safe operation, making it perfect for families with children."
  }, {
    question: 'How Fast Does It Peel?',
    answer: "The KNOVA™ peels most fruits and vegetables in just 5-10 seconds! That's up to 10x faster than manual peeling. You can prepare ingredients for an entire meal in minutes instead of spending time on tedious prep work."
  }, {
    question: 'Is It Easy To Clean?',
    answer: 'Yes! The peeler disassembles easily for quick cleaning. All removable parts are dishwasher safe, and the compact design means there are no hard-to-reach areas. Most users clean it in under a minute.'
  }, {
    question: 'Is It Compact For Small Kitchens?',
    answer: 'Definitely! The KNOVA™ has a space-saving design that fits easily on any countertop or in a drawer. Its compact size (approximately 8" x 6") makes it perfect for apartments, RVs, and kitchens with limited counter space.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full max-w-[1400px] mt-16 px-4 mb-16" data-id="element-244">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 md:mb-12" data-id="element-245">
        Frequently Asked Questions
      </h2>

      <div className="max-w-4xl mx-auto space-y-4" data-id="element-246">
        {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border-2 border-gray-200 overflow-hidden transition-all" data-id="element-247">
            {/* Question Header */}
            <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-248">
              <h3 className="text-base md:text-lg font-bold text-black pr-4" data-id="element-249">
                {faq.question}
              </h3>
              <div className="flex-shrink-0" data-id="element-250">
                {openIndex === index ? <Minus className="w-6 h-6 text-black" strokeWidth={2.5} data-id="element-251" /> : <Plus className="w-6 h-6 text-black" strokeWidth={2.5} data-id="element-252" />}
              </div>
            </button>

            {/* Answer Content */}
            <div className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`} data-id="element-253">
              <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0" data-id="element-254">
                <p className="text-gray-700 text-sm md:text-base leading-relaxed" data-id="element-255">
                  {faq.answer}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}